import { useState } from "react";
import { MESES, DIAS_SEMANA, fmt } from "../constants";

export default function CalendarioFinanceiro({contasPagar, contasReceber}) {
  const agora = new Date();
  const [mesV, setMesV] = useState(agora.getMonth());
  const [anoV, setAnoV] = useState(agora.getFullYear());
  const primeiroDia = new Date(anoV, mesV, 1).getDay();
  const diasNoMes   = new Date(anoV, mesV+1, 0).getDate();
  const eventosNoDia = (dia) => {
    const d = `${anoV}-${String(mesV+1).padStart(2,"0")}-${String(dia).padStart(2,"0")}`;
    return {
      pagar:   contasPagar.filter(c=>c.data_vencimento===d&&["PENDENTE","VENCIDO"].includes(c.status)),
      receber: contasReceber.filter(c=>c.data_vencimento===d&&["PENDENTE","VENCIDO"].includes(c.status)),
    };
  };
  const celulas = [];
  for(let i=0;i<primeiroDia;i++) celulas.push(null);
  for(let i=1;i<=diasNoMes;i++) celulas.push(i);
  return(
    <div style={{background:"#fff",borderRadius:8,padding:16,boxShadow:"0 1px 4px rgba(0,0,0,0.06)",marginBottom:16}}>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
        <button className="btn btn-secondary" style={{padding:"3px 10px"}} onClick={()=>{if(mesV===0){setMesV(11);setAnoV(a=>a-1);}else setMesV(m=>m-1);}}>‹</button>
        <strong style={{fontSize:15}}>{MESES[mesV]} {anoV}</strong>
        <button className="btn btn-secondary" style={{padding:"3px 10px"}} onClick={()=>{if(mesV===11){setMesV(0);setAnoV(a=>a+1);}else setMesV(m=>m+1);}}>›</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:4}}>
        {DIAS_SEMANA.map(d=><div key={d} style={{textAlign:"center",fontSize:11,fontWeight:600,color:"var(--z-text-muted)",padding:"4px 0"}}>{d}</div>)}
        {celulas.map((dia,i)=>{
          if(!dia) return <div key={"e"+i}/>;
          const {pagar,receber}=eventosNoDia(dia);
          const isHoje=dia===agora.getDate()&&mesV===agora.getMonth()&&anoV===agora.getFullYear();
          return(
            <div key={dia} style={{minHeight:60,border:"1px solid "+(isHoje?"var(--z-blue)":"var(--z-border)"),borderRadius:6,padding:"4px 6px",background:isHoje?"#eff6ff":"#fff"}}>
              <div style={{fontSize:12,fontWeight:isHoje?700:400,color:isHoje?"var(--z-blue)":"var(--z-text-secondary)",marginBottom:2}}>{dia}</div>
              {pagar.map(c=>(
                <div key={"p"+c.id} title={c.descricao} style={{fontSize:10,background:"#fee2e2",color:"#dc2626",borderRadius:3,padding:"1px 4px",marginBottom:2,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>
                  ↓ R$ {fmt(c.valor)}
                </div>
              ))}
              {receber.map(c=>(
                <div key={"r"+c.id} title={c.descricao} style={{fontSize:10,background:"#dcfce7",color:"#16a34a",borderRadius:3,padding:"1px 4px",marginBottom:2,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>
                  ↑ R$ {fmt(c.valor)}
                </div>
              ))}
            </div>
          );
        })}
      </div>
      <div style={{display:"flex",gap:16,marginTop:8,fontSize:11}}>
        <span><span style={{display:"inline-block",width:12,height:12,background:"#fee2e2",borderRadius:2,marginRight:4}}/> A Pagar</span>
        <span><span style={{display:"inline-block",width:12,height:12,background:"#dcfce7",borderRadius:2,marginRight:4}}/> A Receber</span>
      </div>
    </div>
  );
}
